import { DataPoint } from 'Interfaces/DataPoint';
import { FormInterface } from 'Interfaces/Forms/FormsInterface';
import { QuestionInterface, questionTypes } from 'Interfaces/Forms/QuestionInterface';
import jsPDF from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import { isNullOrUndefined } from 'utils/utils';


export const generatePdf = (dataPoints: DataPoint[], forms: FormInterface[]) => {
  return getDataPointHtml(dataPoints, forms);
};

export const getDataPointHtml = (dataPoints: DataPoint[], forms: FormInterface[]) => {
  const form = forms.find(f => f.ref === dataPoints[0].questionnaire_id);
  const jsPdf = new jsPDF();
  if (form && form.questionPage) {
    for (const dataPoint of dataPoints) {
      for (const page of form.questionPage) {
        if (page.question) {
          // html.push(`<tr><td colspan="2">${page.name}</td></tr>`);
          const dataHtml = getQuestionValues(dataPoint, page.question, forms);
          for (const h of dataHtml) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(h, 'text/html');
            const tableElement = doc.body.firstChild as HTMLTableElement;
            autoTable(jsPdf, { html: tableElement, startY: jsPdf.lastAutoTable?.finalY + 5 });
          }
          // html.push(getQuestionValues(dataPoint, page.question, forms).join(''));
        }
      }
      if (dataPoints.length > 1) {
        const y = jsPdf.lastAutoTable?.finalY || 5;
        jsPdf.line(5, y + 2, 200, y + 2);
      }
    }
  }
  const file = jsPdf.output('datauristring');
  return file;
  // html.push('</table>');
  // console.log(html.join(''));
  // return html;
};

const isValid = (dataPoint: DataPoint, qn: QuestionInterface) => {
  return !isNullOrUndefined(dataPoint[qn.id]) && !qn.inVisible && !qn.deleted;
};

export const getQuestionValues = (dataPoint: DataPoint, questions: QuestionInterface[], forms: FormInterface[]) => {
  const template = `<tr><td><strong>{{title}}</strong></td><td>{{value}}<td></tr>`;
  const html: string[] = ['<table>'];
  const tableHtml: string[] = [];
  for (const qn of questions) {
    if (isValid(dataPoint, qn)) {
      switch (qn.type) {
        case questionTypes.SELECT_MULTIPLE_QUESTION:
        case questionTypes.SELECT_ONE_QUESTION:
        case questionTypes.LIKERT_SCALE_QUESTION:
        case questionTypes.STATUS_QUESTION:
        case questionTypes.RANK_ORDER_QUESTION: {
          const value = getSelectQuestionValues(dataPoint, qn);
          html.push(template.replace('{{title}}', qn.text).replace('{{value}}', value));
          break;
        }
        case questionTypes.FILE_QUESTION:
        case questionTypes.LABEL:
        case questionTypes.PART_OF_QUESTION:
        case questionTypes.SKIP_QUESTION:
        case questionTypes.PICTURES_QUESTION:
        case questionTypes.TASK_QUESTION:
        case questionTypes.LAYOUT_TABLE_QUESTION:
        case questionTypes.DIGITAL_SIGNATURE_QUESTION:
          break;
        case questionTypes.TABLE_QUESTION:
        case questionTypes.REFERENCE_TABLE_QUESTION: {
          const tableData = getTableQuestionValues(dataPoint, qn, forms);
          html.push('</table>');
          tableHtml.push(html.join(''));
          tableHtml.push(`<table>${tableData}</table>`);
          html.splice(0);
          html.push('<table>');
          break;
        }
        case questionTypes.GPS_QUESTION: {
          const gps = getGPSValue(`${dataPoint[qn.id]}`);
          html.push(template.replace('{{title}}', qn.text).replace('{{value}}', `${gps}`));
          break;
        }
        default: {
          const v = dataPoint[qn.id];
          html.push(template.replace('{{title}}', qn.text).replace('{{value}}', v));
          break;
        }
      }
    }
    const subQ = checkSubQuestions(dataPoint, qn, forms);
    if (subQ.length) {
      html.push('</table>');
      tableHtml.push(html.join(''));
      tableHtml.push(subQ.join(''));
      html.splice(0);
      html.push('<table>');
    }
  }
  html.push('<table>');
  tableHtml.push(html.join(''));
  return tableHtml;
};

export const checkSubQuestions = (dataPoint: DataPoint, qn: QuestionInterface, forms: FormInterface[]) => {
  const html: string[] = [];
  if (qn.triggerValues) {
    const tv = qn.triggerValues.triggerValue;
    for (const t of tv) {
      if (t.action.subQuestions) {
        const h = getQuestionValues(dataPoint, t.action.subQuestions.question, forms);
        html.push(h.join(''));
      }
    }
  }
  return html;
};

const getGPSValue = (gps: string) => {
  if (gps.indexOf('POINT(') !== -1) {
    const cleanGPS = gps.replace('POINT(', '').replace(')', '').split(' ');
    return `${cleanGPS[1]}, ${cleanGPS[0]}`;
  } else {
    const cleanGPS = gps.split(' ');
    return `${cleanGPS[0]}, ${cleanGPS[1]}`;
  }
};

const getSelectQuestionValues = (dataPoint: DataPoint, qn: QuestionInterface) => {
  const value = `${dataPoint[qn.id]}`.split(',').map(v => v.trim());
  const optValues: string[] = [];
  qn.listItems?.listItem.forEach(li => {
    if (li.id && value.indexOf(li.id) > -1) {
      optValues.push(li.value);
    }
  });
  return optValues.join(',');
};

const getTableQuestionValues = (dataPoint: DataPoint, qn: QuestionInterface, forms: FormInterface[]) => {
  const rows = dataPoint[qn.id];
  const relation = qn.table?.columns.relation;
  if (relation && relation.length) {
    const rel = relation[0];
    const tableForm = forms.find(f => f.ref === rel.ref);
    if (tableForm && tableForm.question) {
      const html: string[] = [];
      let first = true;
      const header: string[] = [];
      for (const dp of rows) {
        const row: string[] = [];
        for (const q of tableForm.question) {
          if (!q.inVisible && !q.deleted) {
            if (first) {
              header.push(`<td>${q.text}</td>`);
            }
            if (!isNullOrUndefined(dp[q.id])) {
              switch (q.type) {
                case questionTypes.SELECT_MULTIPLE_QUESTION:
                case questionTypes.SELECT_ONE_QUESTION:
                case questionTypes.LIKERT_SCALE_QUESTION:
                case questionTypes.STATUS_QUESTION:
                case questionTypes.RANK_ORDER_QUESTION: {
                  const value = getSelectQuestionValues(dp, q);
                  row.push(`<td>${value}</td>`);
                  break;
                }
                default:
                  row.push(`<td>${dp[q.id]}</td>`);
              }
            } else {
              row.push(`<td></td>`);
            }
          }
        }
        if (first) {
          html.push(header.join(''));
          first = false;
        }
        html.push(`<tr>${row.join('')}</tr>`);
      }
      return html.join('');
    }
  }
  return '';
};
